// extracted by mini-css-extract-plugin
module.exports = {"root":"PreviewRoll-styles-module--root--3iK50","container":"PreviewRoll-styles-module--container--3pnMa","item":"PreviewRoll-styles-module--item--1vhTb"};